import { useState, useEffect } from "react"
import styles from '@/styles/productDetail/productReviews.module.scss'
import Link from 'next/link'
import GoogleReviewIcon from '@/svgs/googleReviewIcon.svg'
import GoogleLogo from '@/svgs/google.svg'
import { Rate, Spin, Empty, message } from 'antd'
import productApi from '@/service/modules/productApi'
import { paginationChange } from "@/utils/utils"
import ReviewConfig from "./components/ReviewConfig"
import Chart from "./components/Chart"

export default function GoogleReviews(props: any) {

  const defaultgoogleData = {
    googleReview: [],
    googleReviewCount: 0,
    googleScoreReview: [
      {
        count: 0,
        avgScore: 0,
        item: {
          rating1: 0,
          rating2: 0,
          rating3: 0,
          rating4: 0,
          rating5: 0
        }
      }
    ]
  }
  const defaultPages = 1
  const defaultPageSize = 3
  const defalueSort = ""

  const [googleData, setgoogleData]: any = useState(defaultgoogleData)
  const [googleScoreReview, setGoogleScoreReview] = useState({ count: 0, item: {}, avgScore: 0 })
  const [sort, setSort] = useState(defalueSort)
  const [pages, setPages] = useState(defaultPages)
  const [pageSize, setPageSize] = useState(defaultPageSize)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    getReviews()
  }, [pages, pageSize, sort])

  const getReviews = async () => {
    setLoading(true)
    const range = paginationChange(pages, pageSize)
    try {
      let res = await productApi.getGoogleReviews({
        productID: props.productID,
        sort: sort,
        start: range.start,
        rows: range.end
      })
      setLoading(false)
      if (res.data) {
        let newData = res.data
        const { googleScoreReview } = res.data

        const tabList = [
          { id: 1, name: 'Customer Reviews' },
          { id: 2, reactNode: <div className={styles['custom-box']}><GoogleReviewIcon style={{ width: '24px', height: "24px", verticalAlign: 'bottom' }} />  {googleScoreReview[0].avgScore} stars with {googleScoreReview[0].count}+ reviews</div> }
        ]
        props.changeTabBar(tabList)
        if (googleScoreReview) {
          setGoogleScoreReview(googleScoreReview[0])
        }
        setgoogleData(newData)
      }
    } catch (error: any) {
      setLoading(false)
      // message.error(error.message)
      console.error(error)
    }
  }
  const onpageChange = (page: number, pageSize: number) => {
    setPages(page)
    setPageSize(pageSize)
  }

  const sortChange = (evnet: any) => {
    setSort(evnet)
  }

  return (
    <Spin spinning={loading}>
      <div className={styles['info-box']}>
        <div className={`${styles['left']} ${styles['google']}`}>
          <div className={styles['title']}>
            <GoogleReviewIcon></GoogleReviewIcon>
            <h3>Crazysales Review From Google</h3>
          </div>
          <div className={styles['rate']}>
            <span className={styles['score']}>{googleScoreReview.avgScore}</span>
            <Rate count={5} value={googleScoreReview.avgScore} style={{ fontSize: '24px' }} allowHalf={true} disabled />
          </div>
          <p className={styles['total']}>{googleScoreReview.count} Reviews in total</p>
          <Link href={`/review`} legacyBehavior >
            <a className={styles['see-review']}>See All Google Reviews</a>
          </Link>
          <p className={styles['desc']}>Based on customer reviews and data from Google and/or its partners.</p>
        </div>

        <div className={styles['right']}>
          <div className={styles['title']}>What people are saying</div>
          <Chart reviewSummary={googleScoreReview.item} reviewCount={googleScoreReview.count} />
        </div>
      </div>

      <div className={`${styles['list-box']} ${styles['google']}`}>
        <ReviewConfig sort={sort} pages={pages} pageSize={pageSize} total={googleData.googleReviewCount} onpageChange={onpageChange} sortChange={sortChange} productID={props.productID} activeTab={1} />
        <div className={styles['review-list']}>
          {
            googleData.googleReview.length > 0
              ?
              googleData.googleReview.map((item: any, index: number) => (
                <div className={styles['list-item']} key={index}>
                  <div className={styles['head']}>
                    <div className={styles['left']}>
                      <span className={styles['username']}>{item.name}</span>
                      <Rate count={5} value={item.star} style={{ fontSize: '14px' }} allowHalf={true} disabled />
                    </div>
                  </div>
                  <div className={styles['time']}>{item.createTime}</div>
                  <div className={styles['content']}>
                    <p>{item.review}</p>
                    <div className={styles['google-img']}><GoogleLogo /></div>
                  </div>
                </div>
              ))
              :
              <Empty description="* Get double crazypoints if your review is one of the first three approved!" />
          }
        </div>
        {
          googleScoreReview.count > 3
          &&
          <ReviewConfig sort={sort} pages={pages} pageSize={pageSize} total={googleData.googleReviewCount} onpageChange={onpageChange} sortChange={sortChange} productID={props.productID} activeTab={1} />
        }
      </div>
    </Spin>
  )
}